/**
 * Checks if the user agent already supports the PointerEvent constructor
 * @type {boolean}
 */
export const SUPPORTS_POINTER_EVENTS = "PointerEvent" in window;
